import React from 'react';
import { useDispatch } from 'react-redux';
import { addToCart } from '../../redux/cart/actions';
import { decrementProductQuantity } from '../../redux/productItems/actions';

export default function ProductItem({product}) {
  const { imageUrl, productName, category, price, quantity } = product;

  const dispatch = useDispatch();

  const clickHandler = (event) => {
    event.preventDefault();
    dispatch(addToCart({
      id: product.id,
      quantity: 1,
    }))
    dispatch(decrementProductQuantity(product.id));
  }

  return (
    <div className="lws-productCard">
      <img className="lws-productImage" src={imageUrl} alt="product" />
      <div className="p-4 space-y-2">
        <h4 className="lws-productName">{productName}</h4>
        <p className="lws-productCategory">{category}</p>
        <div className="flex items-center justify-between pb-2">
          <p className="productPrice">BDT <span className="lws-price">{price}</span></p>
          <p className="productQuantity">QTY <span className="lws-quantity">{quantity}</span></p>
        </div>
        <button className="lws-btnAddToCart" onClick={clickHandler}>Add To Cart</button>
      </div>
    </div>
  )
}
